import { SxProps, Theme } from '@mui/material'

export const educationCardStyles: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: 1,
	bgcolor: '#DCEFFE',
	color: 'primary.dark',
	px: '16px',
	py: '6px',
	minHeight: '48px',
	borderRadius: 1,
	boxShadow: (theme) => theme.shadows[2],
	boxSizing: 'border-box',
}

export const infoIconStyles = {
	color: '#4AA4EF',
	width: 22,
	height: 22,
}

export const messageTypographyStyles = {
	fontFamily: 'Roboto',
	fontSize: 14,
}
